import React from 'react';
import { IOrderResponse } from '../../../../../../Interfaces/responseTypes';
import styles from './printInvoiceDialog.module.scss';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import usePrintInvoiceHook from './printInvoice-hook';
import Button from '../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../Interfaces/componentTypes';

export interface IPrintInvoiceProps {
    order: IOrderResponse,
    QR: string,
    onClose: () => void
}

const PrintInvoiceDialog: React.FC<IPrintInvoiceProps> = (props) => {
    const { t } = useLanguagesHooks();
    const { onClose } = props;
    const {
        langItems,
        paperSizes,
        selectedLanguage,
        selectedPaperSize,
        onPrint,
        setSelectedLanguage,
        setSelectedPaperSize,
    } = usePrintInvoiceHook(props)
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <p>
                    {t('My_Business.Invoice_Dialog.Header')}
                </p>
            </div>
            <div className={styles.form}>
                <div className={styles.item}>
                    <p className={styles.itemLabel}>
                        {t('My_Business.Invoice_Dialog.Language')}
                    </p>
                    <div className={styles.itemBody}>
                        {
                            langItems.map((lang) => {
                                return (
                                    <div
                                        key={lang.value}
                                        onClick={() => setSelectedLanguage(lang.value)}
                                        className={
                                            `${styles.langItem}
                                         ${selectedLanguage === lang.value && styles.selectedLang}`}
                                    >
                                        <img src={lang.icon} alt='flaf.svg' />

                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className={styles.item}>
                    <p className={styles.itemLabel}>
                        {t('My_Business.Invoice_Dialog.Paper')}
                    </p>
                    <div className={styles.itemBody}>
                        {
                            paperSizes.map((size) => {
                                return (
                                    <div
                                        key={size}
                                        className={`${styles.paper} ${selectedPaperSize === size && styles.selectedPaper}`}
                                        onClick={() => setSelectedPaperSize(size)}
                                    >
                                        <p>{size} <span>{t('My_Business.Invoice_Dialog.MM')}</span></p>

                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.buttonRow}>
                <Button
                    buttonType={ButtonTypes.Secondary}
                    title={t('Buttons.Close')}
                    onClick={() => onClose()}
                />
                <Button
                    buttonType={ButtonTypes.Primery}
                    title={t('My_Business.Invoice_Dialog.Print')}
                    onClick={onPrint}
                />
            </div>
        </div>
    )
}

export default PrintInvoiceDialog
